import React from 'react'
import { Animated, Text } from 'react-native'
import { useReducedMotion } from 'react-native-reanimated'

const VISIBLE_MS = 2400
const FADE_MS = 600

/**
 * A small "Saved" confirmation that fades out after about 3 seconds and then
 * calls `onDone`. Remount it (new `key`) to show it again.
 */
export function SavedBadge({ onDone, visibleMs = VISIBLE_MS, textClassName = 'font-typed text-[10px] text-olive-up', label = 'Saved' }: {
  onDone: () => void
  visibleMs?: number
  textClassName?: string
  label?: string
}) {
  const reducedMotion = useReducedMotion()
  const opacity = React.useRef(new Animated.Value(1)).current
  React.useEffect(() => {
    const fade = Animated.timing(opacity, { toValue: 0, duration: reducedMotion ? 0 : FADE_MS, delay: visibleMs, useNativeDriver: true })
    fade.start(({ finished }) => { if (finished) onDone() })
    return () => fade.stop()
  }, [opacity, onDone, visibleMs, reducedMotion])
  return (
    // Fade the wrapper, not the text: NativeWind classes don't apply to
    // Animated.Text, which left it uncolored (black) on the dark theme.
    <Animated.View style={{ opacity }}>
      <Text className={textClassName} accessibilityLiveRegion="polite">{label}</Text>
    </Animated.View>
  )
}
